export class HeaderSearchResult {
	private element: HTMLElement;
	private readonly activeClass: string = 'header-search-result--active';

	constructor(element) {
		if (!element) return;
		this.element = element;

		this.init();
	}

	public open = (): void => {
		this.element.classList.add(this.activeClass);
		setTimeout(() => window.addEventListener('click', this.handleWindowClick), 100);
	};

	public close = (): void => {
		this.element.classList.remove(this.activeClass);
		window.removeEventListener('click', this.handleWindowClick);
	};

	private handleWindowClick = ({ target }): void => {
		if (!target.closest('.header-search')) this.close();
	};

	public init = (): void => {
		
	};
}
